import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "Scroll" }
const _hoisted_2 = { viewBox: "0 0 24 40" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  x: "0.5",
  y: "0.5",
  width: "23",
  height: "39",
  rx: "11.5"
}, null, -1)
const _hoisted_4 = {
  ref: "dot",
  x1: "12",
  y1: "10",
  x2: "12",
  y2: "30"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("line", _hoisted_4, null, 512)
    ])),
    _createElementVNode("span", null, _toDisplayString(_ctx.$t('chapter.scroll')), 1)
  ]))
}